export { default } from './TextBanner';
